(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

(function ($) {
  var bounds,
    infoWindow,
    map,
    marker,
    markers,
    windowScrollPosition = -1;

  // IE Mobile fix
  if ('-ms-user-select' in document.documentElement.style && navigator.userAgent.match(/IEMobile\/10\.0/)) {
    var a = document.createElement('style');
    a.appendChild(document.createTextNode('@-ms-viewport{width:auto!important}'));
    document.getElementsByTagName('head')[0].appendChild(a);
  }

  // Add dashboard link for logged-in admin users
  var addDashboardLinkIfNeeded = function addDashboardLinkIfNeeded() {
    if (1 == MSWObject.show_dashboard_link) {
      $('<a href="' + MSWObject.home_url + '/wp-admin" id="msw-dashboard" title="Dashboard" rel="nofollow" target="_blank"><img src="' + MSWObject.site_url + '/wp-admin/images/w-logo-white.png" height="24" width="24" alt="Dashboard"></a>').appendTo('body');
    }
  };
  var createGoogleMap = function createGoogleMap() {
    if (MSWObject.google_map_data) {
      var markers = JSON.parse(MSWObject.google_map_data);
      var singleMarker = [];
      var locationId;
      var markerMatchesLocationId = function markerMatchesLocationId(marker) {
        return marker.location_id == locationId;
      };
      if (document.getElementById('gmap')) {
        //Check that markers exist
        if (markers.length == 0) {
          return;
        }

        //Check if single-location or multiple locations
        if (document.querySelector('[data-gmapSingleLocation]')) {
          locationId = document.querySelector('[data-gmapSingleLocation]').getAttribute('data-gmapSingleLocation');
          singleMarker.push(markers.find(markerMatchesLocationId));
          createGoogleMapInit(singleMarker);
        } else {
          createGoogleMapInit(markers);
        }
      }
    }
  };
  var createGoogleMapInit = function createGoogleMapInit(markers) {
    var maxZoom = document.getElementById('gmap').getAttribute('data-maxZoom');
    var minZoom = document.getElementById('gmap').getAttribute('data-minZoom');
    var styles = document.getElementById('gmap').getAttribute('data-styles');
    map = new google.maps.Map(document.getElementById('gmap'), {
      center: {
        lat: -38.216996,
        lng: -85.575
      },
      disableDoubleClickZoom: true,
      draggable: false,
      mapTypeControl: false,
      scrollwheel: false,
      styles: styles || [],
      minZoom: minZoom || 1,
      maxZoom: maxZoom || 18
    });
    bounds = new google.maps.LatLngBounds();
    infoWindow = new google.maps.InfoWindow();
    var infoWindowContent = [];
    for (var i = 0; i < markers.length; i++) {
      var position = new google.maps.LatLng(markers[i].lat, markers[i].lng);
      bounds.extend(position);
      marker = new google.maps.Marker({
        icon: markers[i].marker,
        position: position,
        map: map
      });
      map.fitBounds(bounds);
      var locationContent = '<a href="';
      locationContent += markers[i].location_url;
      locationContent += '" class="button">';
      locationContent += markers[i].location_name;
      locationContent += '</a>';
      infoWindowContent.push(locationContent);
      google.maps.event.addListener(marker, 'click', function (marker, i) {
        return function () {
          infoWindow.setContent(infoWindowContent[i]);
          infoWindow.open(map, marker);
        };
      }(marker, i));
      google.maps.event.addListener(marker, 'closeclick', function (marker, i) {
        return function () {
          map.fitBounds(bounds);
        };
      }(marker, i));
    }
    google.maps.event.addDomListener(window, 'resize', function () {
      map.fitBounds(bounds);
    });
  };

  // Toggle "scrolled" body class when site is scrolled or at the top
  var isSiteScrolled = function isSiteScrolled() {
    var top = window.pageYOffset;
    if (windowScrollPosition != top) {
      windowScrollPosition = top;
      if (0 < top) {
        $('body').addClass('scrolled');
      } else {
        $('body').removeClass('scrolled');
      }
    }
  };

  // Add nav menu functionality if using one of the built-in menus
  var shouldConstructNavMenu = function shouldConstructNavMenu() {
    if (!$('body').hasClass('nav-custom')) {
      // Add sub-menu functionality when clicked.
      // If a link is just a hash, toggle it on click.
      $('body').on('click', '.menu-item-has-children a', function (ev) {
        var isTrigger = /#/.test(this.href);
        var thisParent = $(this).parentsUntil('ul');
        if (isTrigger) {
          ev.preventDefault();
          $(thisParent).toggleClass('menu-item-open');
        }
        thisParent.siblings('.menu-item-has-children').not($(thisParent)).removeClass('menu-item-open');
      });

      // Click arrow to open sub-menu
      $('body').on('click', '.ocn-sub-menu-button', function (ev) {
        var thisParent = $(this).parentsUntil('ul');
        var ariaPressed = $(this).attr('aria-pressed') == 'true';
        $(this).attr('aria-pressed', !ariaPressed);
        $(thisParent).toggleClass('menu-item-open');
        thisParent.siblings('.menu-item-has-children').not($(thisParent)).removeClass('menu-item-open');
      });

      // If using the built-in offcanvas nav, add the overlay at the end of the document
      if ($('body').hasClass('nav-ocn')) {
        $('<a href="javascript:void(0)" class="nav-toggle" id="ocn-overlay"></a>').appendTo('body');
      }

      // Anything with the .nav-toggle class should toggle the menu class.
      $('body').on('click', '.nav-toggle', function (ev) {
        ev.preventDefault();
        $('body').toggleClass('nav-open');
        var ariaPressed = $('.nav-toggle').attr('aria-pressed') == 'true';
        $('.nav-toggle').attr('aria-pressed', !ariaPressed);
      });
    }
  };
  var filterDropdown = function filterDropdown() {
    $('.filter-dropdown').on('click', function (e) {
      e.stopPropagation();
      $(this).toggleClass('active');
      $('.filter-dropdown').not(this).removeClass('active');
    });
    $(document).on('click.closefilter', ':not(.filter-dropdown)', function () {
      $('.filter-dropdown').removeClass('active');
    });
  };
  var popUpImg = function popUpImg() {
    var _$;
    (_$ = $('[data-action="popup-img"]')) === null || _$ === void 0 ? void 0 : _$.magnificPopup({
      type: 'image'
    });
  };
  var popUpGallery = function popUpGallery() {
    $('[data-action="popup-gallery"]').magnificPopup({
      delegate: 'a',
      type: 'image',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1]
      }
    });
  };
  $(document).ready(function () {
    shouldConstructNavMenu();
    isSiteScrolled();
    addDashboardLinkIfNeeded();
    filterDropdown();
    popUpImg();
    popUpGallery();
    optimizedScroll.add(isSiteScrolled);
  });
  $(window).load(function () {
    createGoogleMap();
  });
})(jQuery);

},{}],2:[function(require,module,exports){
"use strict";

window.optimizedResize = function () {
  var callbacks = [],
    running = false;
  function resize() {
    if (!running) {
      running = true;
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(runCallbacks);
      } else {
        setTimeout(runCallbacks, 66);
      }
    }
  }
  function runCallbacks() {
    callbacks.forEach(function (callback) {
      callback();
    });
    running = false;
  }
  function addCallback(callback) {
    if (callback) {
      callbacks.push(callback);
    }
  }
  return {
    add: function add(callback) {
      if (!callbacks.length) {
        window.addEventListener('resize', resize);
      }
      addCallback(callback);
    }
  };
}();
window.optimizedScroll = function () {
  var callbacks = [],
    running = false;
  function scroll() {
    if (!running) {
      running = true;
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(runCallbacks);
      } else {
        setTimeout(runCallbacks, 66);
      }
    }
  }
  function runCallbacks() {
    callbacks.forEach(function (callback) {
      callback();
    });
    running = false;
  }
  function addCallback(callback) {
    if (callback) {
      callbacks.push(callback);
    }
  }
  return {
    add: function add(callback) {
      if (!callbacks.length) {
        window.addEventListener('scroll', scroll);
      }
      addCallback(callback);
    }
  };
}();

},{}],3:[function(require,module,exports){
"use strict";

require('./framework');
require('./optimized-events');
require('./theme');
require('./woocommerce');

},{"./framework":1,"./optimized-events":2,"./theme":4,"./woocommerce":5}],4:[function(require,module,exports){
"use strict";

(function ($) {
  var docReady = function docReady() {
    initFancybox();
    initializeProductCarousel();
    productCardListener();
    addIconsToLists();
    setProductScrollHeight();
    appendFontAwesomeIcon($('.preowned__search-form .ginput_container_select'));
    removeSvgAttrs();
    productCardListener();
    setProductScrollHeight();
    appendFontAwesomeIcon($('.preowned__search-form .ginput_container_select'));
    hideEmptySections();
    sortByOnSubmit();
    removeSvgAttrs();
  };
  $(document).ready(function () {
    docReady();
  });
  function initFancybox() {
    console.log('init fancybox');
    Fancybox.bind('[data-fancybox]');
    console.log(Fancybox);
  }
  function setGalleryImageHeight($card) {
    var $parentContainer = $card.closest('.product-single__content-container');
    if ($parentContainer.length) {
      var $content = $parentContainer.find('.product-single__content').first();
      var $gallery = $parentContainer.find('.product-single__gallery').first();
      var contentHeight = $content.innerHeight();
      $gallery.height(contentHeight);
    }
  }

  /**
   * click listener for slideToggle collapsible product cards
   */
  function productCardListener() {
    var $cards = $('.product-card');
    if ($cards.length) {
      $cards.each(function (index, element) {
        // on load
        $(element).find('.product-card__content').slideUp(function () {
          toggleAccordionHeader($(this));
          setGalleryImageHeight($(this));
        });

        // on click
        $(element).find('.product-card__header').click(function () {
          $(this).siblings().first().slideToggle(function () {
            toggleAccordionHeader($(this));
            setGalleryImageHeight($(this));
          });
        });
      });
    }
  }

  /**
   * class toggle for product card listener:
   *     toggles +/- icon in header
   */
  function toggleAccordionHeader($element) {
    $element.parent().find('.product-card__header').toggleClass('product-card__header--active');
  }

  /**
   * adds angle-down icon to dropdowns for gravity forms
   *
   * @param  {$element} element
   */
  function appendFontAwesomeIcon(element) {
    element.addClass('fa fa-angle-down');
  }

  /**
   * sets overall scroll height for preowned product card
   *     since the section is set to overflow/scroll, this sets the height
   *     such that the main content can be seen on load.
   */
  function setProductScrollHeight() {
    var mediaQuery = window.matchMedia('(min-width: 1024px)');
    if (mediaQuery.matches) {
      setTimeout(function () {
        var $contactBar = $('.product-detail__contact-bar--preowned').first();
        var $container = $('.preowned-detail__content-container').first();
        var containerPadding = parseInt($container.css('paddingBottom'));
        var contactBarHeight = $contactBar.innerHeight();
        $container.css('paddingBottom', contactBarHeight);
      }, 250);
    }
  }

  /**
   * simply removes static width/height attrs from svg
   */
  function removeSvgAttrs() {
    var _$wrappers;
    $wrappers = $('.new-trucks-trailers__item-star-wrap');
    if ((_$wrappers = $wrappers) !== null && _$wrappers !== void 0 && _$wrappers.length) {
      $wrappers.each(function (index, element) {
        var $star = $(element).find('svg');
        $star.removeAttr('width', '');
        $star.removeAttr('height', '');
      });
    }
  }

  /**
   * product carousel, swiper initialization
   */
  function initializeProductCarousel() {
    console.log('initializeProductCarousel');

    //* Component gallery
    var galleryThumbs = new Swiper('.gallery-thumbs', {
      spaceBetween: 10,
      slidesPerView: 9,
      reverseDirection: true,
      // loop: true,
      // freeMode: true,
      // watchSlidesVisibility: true,
      // watchSlidesProgress: true,
      breakpoints: {
        320: {
          slidesPerView: 3
        },
        640: {
          slidesPerView: 6
        },
        1024: {
          slidesPerView: 9
        }
      }
    });
    var galleryCaptions = new Swiper('.gallery-captions', {
      spaceBetween: 10,
      loop: true,
      // slidesPerView: 1,
      freeMode: false,
      allowTouchMove: false,
      allowSlidePrev: false,
      allowSlideNext: false
    });
    var gallery = new Swiper('.gallery-full', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      thumbs: {
        swiper: galleryThumbs
      },
      controller: {
        control: [galleryCaptions]
      }
    });
    var galleryFull = new Swiper('.gallery-full', {
      // spaceBetween: 10,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
    var galleryFullNoThumbs = new Swiper('.gallery-full-no-thumbs', {
      // spaceBetween: 10,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      controller: {
        control: [galleryFullNoThumbs, galleryCaptions]
      }
    });
    galleryFull.on('slideChangeTransitionEnd', function () {
      console.log('slideChangeTransitionEnd', this);
      galleryThumbs.slideToLoop(this.realIndex);
    });
  }

  /**
   * prepends font-awesome check-circle icons to stylized list divs
   */
  function addIconsToLists() {
    $('.entry-content--stylized-list').each(function (index, element) {
      var $list = $(element).find('ul li');
      $list.each(function (index, element) {
        $(element).prepend('<span class="fa-li"><i class="fas fa-check-circle"></i></span>');
      });
    });
  }
  function hideEmptySections() {
    var $sections = $('.new-detail__section');
    $sections.each(function (index, section) {
      var $section = $(section);
      var $children = $section.children();
      var length = $children.length;
      if (length === 0) {
        $section.remove();
      }
    });
  }
  function getFormUrl(query) {
    return '//' + window.location.host + window.location.pathname + '?' + query;
  }
  function sortByOnSubmit() {
    var $menu = $('#sort-posts');
    $menu.on('change', function () {
      var urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('sort-posts')) {
        urlParams.set('sort-posts', $(this).val());
      } else {
        urlParams.append('sort-posts', $(this).val());
      }
      var formUrl = getFormUrl(urlParams.toString());
      window.location.href = formUrl;

      // console.log(formUrl);
    });
  }
})(jQuery);

},{}],5:[function(require,module,exports){
"use strict";

(function ($) {
  var ajaxAddToCart = function ajaxAddToCart() {
    var atcButton = $('.ms-ajax-add-to-cart');
    var productInfo = {
      id: null,
      type: null,
      slug: null,
      sku: null,
      quantity: 1,
      variations: null,
      groupedProducts: null,
      productBundles: null
    };
    var addToCart = function addToCart(productInfo) {
      var query = $.ajax({
        url: MSWObject.ajax_url,
        method: 'POST',
        data: {
          action: 'ms_ajax_atc',
          woo_ajax_object: productInfo
        },
        fail: function fail(textStatus) {
          console.log(textStatus);
        },
        success: function success() {
          console.log('Successully added to cart.');
          // Do stuff
        }
      });
    };

    atcButton.on('click', function (e) {
      e.preventDefault();
      productInfo.variations = null;
      productInfo.groupedProducts = null;
      productInfo.productBundles = null;
      var target = $(e.currentTarget);
      var productOptions = [];
      productInfo.type = target.attr('data-product_type');
      productInfo.id = target.attr('data-product_id');
      productInfo.slug = target.attr('data-product_slug');
      productInfo.sku = target.attr('data-product_sku');
      productOptionSelector = $('.' + productInfo.id + '-' + productInfo.type + '-' + productInfo.slug);
      productInputSelector = $('.' + productInfo.id + '-' + productInfo.type + '-' + productInfo.slug + '-quantity');
      productInfo.quantity = productInfo.quantity = productInputSelector.val();
      if (productInfo.quantity == '') {
        productInfo.quantity = 1;
      }
      switch (productInfo.type) {
        case 'simple':
          break;
        case 'variable':
          $.each(productOptionSelector, function () {
            var name = $(this).attr('data-variable_name');
            var selected = this.options[this.selectedIndex].text;
            var variation = {
              name: name,
              selected: selected
            };
            productOptions.push(variation);
          });
          productInfo.variations = productOptions;
          break;
        case 'grouped':
          $.each(productOptionSelector, function () {
            var id = $(this).attr('data-product_id');
            var quantity = $(this).find('input').val();
            var childProduct = {
              id: id,
              quantity: quantity
            };
            productOptions.push(childProduct);
          });
          productInfo.groupedProducts = productOptions;
          break;
        default:
          break;
      }
      addToCart(productInfo);
    });
  };
  $(document).ready(function () {
    ajaxAddToCart();
  });
})(jQuery);

},{}]},{},[3])

